<script setup lang="ts">
  import { ref, onMounted, nextTick } from 'vue'
  import copy from 'copy-text-to-clipboard'
  import { Tooltip } from 'bootstrap'

  const props = defineProps({
    text: {
      type: String,
      required: true,
    },
  })

  const copied = ref(false)
  const buttonRef = ref(null)
  let tooltipInstance

  onMounted(async () => {
    let button = buttonRef.value
    if (!button) { return }

    tooltipInstance = new Tooltip(button, {
      title: "Copied!",
      trigger: 'manual'
    })
  })

  const copyToClipboard = async () => {
    copy(props.text)
    copied.value = true
    tooltipInstance.show()
    await nextTick()
    setTimeout(() => {
      copied.value = false
      tooltipInstance.hide()
    }, 1500)
  }
</script>

<template>
  <button ref="buttonRef" class="copy-to-clipboard-button" @click="copyToClipboard" title="Copy to Clipboard" aria-label="Copy to clipboard">
    <glyph name="clipboard" />
  </button>
</template>

<style lang="scss" scoped>
.copy-to-clipboard-button {
  background: none;
  border: none;
  color: #fff;
}
</style>
